import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import GamesSection from "@/components/site/GamesSection";
import BookingCTA from "@/components/home/BookingCTA";
import { SITE } from "@/data/site";

export default function Games() {
  return (
    <PageShell testId="games-page">
      <PageHero
        overline="Play & Unwind"
        title={["Games &", "Activities"]}
        subtitle="From snooker to carrom, there's always something to play at Vruksha Valley."
        image={SITE.heroImage}
      />
      <GamesSection heading={false} />
      <BookingCTA />
    </PageShell>
  );
}
